import { render } from "./footer.vue?vue&type=template&id=43b997de&scoped=true"
const script = {}

import "./footer.vue?vue&type=style&index=0&id=43b997de&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-43b997de"]])

export default __exports__